import React from "react";
import { ChatMessage, isDeletedMessage } from "../../types/chat";
import TextMessage from "../Messages/TextMessage";
import ImageMessage from "../Messages/ImageMessage";
import VideoMessage from "../Messages/VideoMessage";
import AlbumMessage from "../Messages/AlbumMessage";
import FileMessage from "../Messages/FileMessage";
import LinkMessage from "../Messages/LinkMessage";
import LocationMessage from "../Messages/LocationMessage";
import {
  ImageMetadata,
  VideoMetadata,
  AlbumMetadata,
  FileMetadata,
  LinkPreviewMetadata,
  LocationMetadata,
  getMessageContentType,
} from "../../types/chat";
import styles from "./ShareMessageModal.module.scss";

interface MessagePreviewProps {
  message: ChatMessage;
}

const MessagePreview: React.FC<MessagePreviewProps> = ({ message }) => {
  // Check if message is deleted
  if (isDeletedMessage(message)) {
    return (
      <div className={styles.messagePreview}>
        <div className={styles.deletedMessage}>
          <i>Tin nhắn đã thu hồi</i>
        </div>
      </div>
    );
  }

  // Get content type
  const contentType = getMessageContentType(message);

  return (
    <div className={styles.messagePreview}>
      <div className={styles.previewLabel}>Nội dung tin nhắn:</div>
      <div className={styles.previewContent}>
        {contentType === "text" && <TextMessage message={message as any} isOwnMessage={false} />}

        {contentType === "image" && (
          <ImageMessage message={message as any} metadata={message.metadata as ImageMetadata} isOwnMessage={false} />
        )}

        {contentType === "video" && (
          <VideoMessage message={message as any} metadata={message.metadata as VideoMetadata} isOwnMessage={false} />
        )}

        {contentType === "album" && (
          <AlbumMessage message={message as any} metadata={message.metadata as AlbumMetadata} isOwnMessage={false} />
        )}

        {contentType === "file" && (
          <FileMessage message={message as any} metadata={message.metadata as FileMetadata} isOwnMessage={false} />
        )}

        {contentType === "link" && (
          <LinkMessage
            message={message as any}
            metadata={message.metadata as LinkPreviewMetadata}
            isOwnMessage={false}
          />
        )}

        {contentType === "location" && (
          <LocationMessage
            message={message as any}
            metadata={message.metadata as LocationMetadata}
            isOwnMessage={false}
          />
        )}
      </div>
    </div>
  );
};

export default MessagePreview;
